import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { signOut } from '../../store/actions/authActions';

const SignedInLinks = (props) => {
  return (
    <React.Fragment>
      <a href="#" data-target="mobile-demo" className="sidenav-trigger right"><i className="material-icons">menu</i></a>
      <ul id="nav-mobile" className="right hide-on-med-and-down">
        <li><NavLink to='/create' className="waves-effect waves-light hoverable lighten-2 btn">+ New Task</NavLink></li>
        <li><NavLink to='/'>Dashboard</NavLink></li>
        <li><a onClick={ props.signOut }>Log Out</a></li>
        <li><NavLink to='/' className="btn btn-floating pink lighten-1"> { props.profile.initials } </NavLink></li>
      </ul>
      <ul id="mobile-demo" className="sidenav right">
        <li><NavLink to='/create' className="waves-effect waves-light hoverable lighten-2 btn">+ New Task</NavLink></li>
        <li><NavLink to='/'>Dashboard</NavLink></li>
        <li><a onClick={ props.signOut }>Log Out</a></li>
        <li><NavLink to='/' className="btn btn-floating pink lighten-1"> { props.profile.initials } </NavLink></li>
      </ul>
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut())
  }
}


export default connect(null, mapDispatchToProps)(SignedInLinks)